import styles from './FJAIAudioHistory.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import bkBase64 from '../../../../assets/base64/bk.js';
import FJAIAudioItemContainer from '../container/FJAIAudioItemContainer.jsx';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const FJAIAudioHistory = props => {
    const { historyList = [], setIsMultipleMode, isMultipleMode, setSliceSelectList } = props;

    const scrollerRef = useRef(null);

    useEffect(() => {
        scrollerRef.current.scrollTop(0);
    }, [historyList.length]);

    const _setIsMultipleMode = () => {
        if (isMultipleMode) {
            setSliceSelectList([]);
        }
        setIsMultipleMode(!isMultipleMode);
    };

    return (
        <div className={styles.box}>
            <div className={styles.header}>
                <div className={styles.header_mask}>
                    <img src={bkBase64} alt='' />
                </div>
                <div className={styles.content}>
                    <div>
                        <div className={styles.title}>{FJLocalStore._('music-playlist')}</div>
                        <div className={styles.sub_title}>
                            {FJLocalStore._('check-the-music-being-generated-and-the-generation-history-here')}
                        </div>
                    </div>
                    <div className={styles.btn} onClick={_setIsMultipleMode}>
                        {FJLocalStore._(isMultipleMode ? 'cancel' : 'select')}
                    </div>
                </div>
            </div>
            <div className={styles.content_box}>
                <FJVerticalScroller className={styles.scroll} ref={scrollerRef}>
                    <div style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                        {historyList.map(item => {
                            return <FJAIAudioItemContainer key={item.id} item={item} />;
                        })}
                        <div style={{ width: '100%', height: '60px' }} />
                    </div>
                </FJVerticalScroller>
            </div>
        </div>
    );
};
FJAIAudioHistory.propTypes = {
    historyList: PropTypes.array,
    setIsMultipleMode: PropTypes.func,
    isMultipleMode: PropTypes.bool,
    setSliceSelectList: PropTypes.func,
};
export default FJAIAudioHistory;
